"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _reactToastify = require("react-toastify");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _formik = require("formik");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var StyledAppIcon = _styledComponents.default.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  width: 120px;\n  height: 120px;\n  margin: 2rem auto;\n"])));

var ForgotPassword = function ForgotPassword(_ref) {
  var onError = _ref.onError,
      onSuccess = _ref.onSuccess,
      appIconUrl = _ref.appIconUrl;

  var validate = function validate(values) {
    var errors = {};

    if (!values.email) {
      errors.email = "Email Required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }

    return errors;
  };

  var onSubmit = function onSubmit(values, _ref2) {
    var setSubmitting = _ref2.setSubmitting,
        resetForm = _ref2.resetForm;

    _axios.default.post("/auth/passwords/forgot", {
      email: values.email
    }).then(function (_ref3) {
      var data = _ref3.data;
      resetForm();
      setSubmitting(false);

      _reactToastify.toast.success("Password Reset Email Sent");

      if (onSuccess) {
        onSuccess();
      }
    }).catch(function (_ref4) {
      var response = _ref4.response;
      setSubmitting(false);

      _reactToastify.toast.success("Error sending email");

      onError(response);
    });
  };

  return /*#__PURE__*/_react.default.createElement(StyledWrapper, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Card, null, /*#__PURE__*/_react.default.createElement(StyledAppIcon, {
    src: appIconUrl
  }), /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: {
      email: ""
    },
    validate: validate,
    onSubmit: onSubmit
  }, function (_ref5) {
    var isValid = _ref5.isValid,
        values = _ref5.values,
        errors = _ref5.errors,
        touched = _ref5.touched,
        dirty = _ref5.dirty,
        handleChange = _ref5.handleChange,
        handleBlur = _ref5.handleBlur,
        handleSubmit = _ref5.handleSubmit,
        isSubmitting = _ref5.isSubmitting;
    return /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Form, {
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
      type: "email",
      name: "email",
      placeholder: "Enter your email address",
      onChange: handleChange,
      onBlur: handleBlur,
      value: values.email
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
      isVisible: values.email !== "" && errors.email
    }, errors.email), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
      style: {
        marginBottom: "1rem"
      },
      type: "submit",
      isLoading: isSubmitting,
      disabled: !dirty || isSubmitting || !isValid
    }, "Reset password"), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
      type: "button",
      to: "/login",
      isDefault: true
    }, "Back"));
  })));
};

var _default = ForgotPassword;
exports.default = _default;